import { render } from "./pyku.vue?vue&type=template&id=1ddd723d&scoped=true"
import script from "./pyku.vue?vue&type=script&lang=js"
export * from "./pyku.vue?vue&type=script&lang=js"

import "./pyku.vue?vue&type=style&index=0&id=1ddd723d&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddd723d"]])

export default __exports__